// Violet theme
const violet = {
  id: 'violet',
  name: 'Violetti tumma',
  price: 25,
  main: '#8660b1',
  light: '#9c7bb5',
  dark: '#5c3d8a',
  bg: '#ede7f6',
  darkBg: '#1f1a2d',
  isSuper: false,
  surfaces: {
    // Light mode
    lightBg: '#d8ccee',
    lightPaper: '#ede7f6',
    lightContainer: '#ede7f6',
    lightOnSurface: '#1a1a2e',
    lightOnSurfaceVariant: '#554066',
    lightOutline: '#8565a0',
    // Dark mode
    containerLowest: '#161220',
    containerLow: '#08060f',
    container: '#161220',
    containerHigh: '#2c2440',
    containerHighest: '#352c4c',
    bright: '#40365a',
    onSurface: '#ede0ff',
    onSurfaceVariant: '#baa0d4',
    outline: '#8565a0',
    outlineVariant: '#553a6e',
    // Button colors — primary
    primaryContainer: '#9c7bb5',
    onPrimaryContainer: '#1f0a38',
    // Button colors — secondary (outlined)
    secondaryContainer: '#2e1a44',
    onSecondaryContainer: '#c4a8d8',
    // Button colors — secondary (filled)
    secondary: '#b39ddb',
    onSecondary: '#311b5e',
    secondaryLight: '#5c3d8a',
    onSecondaryLight: '#ffffff',
    // Button colors — inverse
    inverseSurface: '#ede7f6',
    onInverseSurface: '#1f1a2d',
    inverseSurfaceLight: '#1f1a2d',
    onInverseSurfaceLight: '#ede0ff',
    // Button colors — label/text
    labelColor: '#9c7bb5',
    labelColorLight: '#5c3d8a',
    // Status colors
    success: '#4caf50',
    successLight: '#81c784',
    successDark: '#2e7d32',
    warning: '#ed6c02',
    warningLight: '#ff9800',
    warningDark: '#e65100',
    error: '#ef5350',
    errorLight: '#ff7961',
    errorDark: '#c62828',
  },
};

export default violet;
